import { Check } from '#components/Check'
import { SuperCounter } from '#components/SuperCounter'
import { log } from '#helpers'
import { endpoints, request, selectors, usePop, useTasks } from '#hooks'
import {
  Button,
  PanelBody,
  PanelRow,
  Spinner,
  TextControl,
} from '@wordpress/components'
import { useEffect, useState } from '@wordpress/element'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export const PerfectTitle = ({ pop }) => {
  const { t } = useTranslation()
  const { tasks, isValidating, mutate } = useTasks(pop)
  const { post } = usePop(pop)

  const condition =
    tasks?.['keyontitle'] &&
    tasks?.['longtitlesingle'] &&
    tasks?.['notitlesingle']

  const [focusKeyword, setFocusKeyword] = useState('')

  const MAX_LENGTH = 70
  const siteNameLength = window.marketgoo.siteName.length + 3
  const maxLengthFinal = MAX_LENGTH - siteNameLength

  const defaultValues = {
    title: '',
  }

  const { watch, handleSubmit, control, setValue } = useForm({
    defaultValues,
  })

  const setTitleAndGetKeyword = () => {
    if (post) {
      setValue('title', post.title.rendered)
      setFocusKeyword(post.postMetaFields?.[selectors.keyword]?.[0])
    }
  }

  useEffect(setTitleAndGetKeyword, [post])

  const onSubmit = (data) => {
    request(endpoints.pop.edit({ ...pop, data }))
      .then(() => {
        mutate()
      })
      .catch(log)
      .finally(() => {
        window.onbeforeunload = null
        window.location.reload()
      })
  }

  return (
    <PanelBody
      title={t('sidebar.perfecttitle.title')}
      icon={isValidating ? <Spinner /> : <Check condition={condition} />}
      initialOpen={!condition}
    >
      <PanelRow>
        <form onSubmit={handleSubmit(onSubmit)}>
          <p>
            {t(
              `sidebar.perfecttitle.intro.${
                focusKeyword ? 'selected' : 'empty'
              }`,
              { focusKeyword, maxLength: MAX_LENGTH }
            )}
          </p>
          <Controller
            name="title"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextControl
                help={t('sidebar.perfecttitle.help', {
                  siteName: window.marketgoo.siteName,
                  count: siteNameLength,
                })}
                label={t('sidebar.perfecttitle.label')}
                maxLength={maxLengthFinal}
                {...field}
              />
            )}
          />
          <p>
            <SuperCounter value={watch('title')} />
          </p>
          <p>
            <Check condition={tasks?.['notitlesingle']} />
            {t('sidebar.perfecttitle.completed.task.notitlesingle')}
          </p>
          <p>
            <Check condition={tasks?.['keyontitle']} />
            {t('sidebar.perfecttitle.completed.task.keyontitle')}
          </p>
          <p>
            <Check condition={tasks?.['longtitlesingle']} />
            {t('sidebar.perfecttitle.completed.task.longtitlesingle', {
              count: MAX_LENGTH,
            })}
          </p>
          <Button type="submit" variant="primary">
            {t('sidebar.perfecttitle.cta')}
          </Button>
        </form>
      </PanelRow>
    </PanelBody>
  )
}
